/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import Navigate from "../../../shared/navigation/navigate";
import { overlayModalStyle } from "../../helpers/ui-helper";
import { routesContext } from "../../../shared/routes/routes-context";
import { showToast } from "../../helpers/show-toast";
class JoinedChallengeModal extends Component {
  static contextType = routesContext;
  componentDidMount = () => Modal.setAppElement(this.props.appElementName);

  render() {
    const { isOpen } = this.props;
    return (
      <Modal
        isOpen={isOpen}
        style={overlayModalStyle}
        className="challenge-modal-dialog"
        contentLabel="Join Challenge Modal"
      >
        <div className="challenge-modal-content">
          <button
            className="challenge-modal_close"
            onClick={this.props.onCloseModal}
            aria-label="Close"
          >
            ✕
          </button>
          <div className="challenge-modal-body">
            <div className="checkmark-container">
              <div
                className="outer-circle"
                style={{
                  width: "80px",
                  height: "80px",
                }}
              >
                <div
                  className="inner-circle"
                  style={{
                    width: "60px",
                    height: "60px",
                  }}
                ></div>
              </div>
            </div>

            <h3
              style={{
                fontSize: "24px",
                fontWeight: "600",
                textAlign: "center",
                marginBottom: "40px",
              }}
            >
              {this.props.title}
            </h3>
            {(this.props.progress ?? 0) > 0 && (
              <>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "2px" }}
                >
                  <div
                    style={{
                      width: "33.3%",
                      height: "10px",
                      backgroundColor:
                        this.props.progress >= 1 ? "#00365F" : "#E0E0E0",
                      borderTopLeftRadius: "5px",
                      borderBottomLeftRadius: "5px",
                      backgroundClip: "content-box", // Ensures neat corners
                    }}
                  ></div>

                  <div
                    style={{
                      width: "33.3%",
                      height: "10px",
                      backgroundColor:
                        this.props.progress >= 2 ? "#00365F" : "#E0E0E0",
                      borderRadius: "0px",
                    }}
                  ></div>

                  <div
                    style={{
                      width: "33.3%",
                      height: "10px",
                      backgroundColor:
                        this.props.progress >= 3 ? "#00365F" : "#E0E0E0",
                      borderTopRightRadius: "5px",
                      borderBottomRightRadius: "5px",
                    }}
                  ></div>
                </div>
                <p
                  style={{
                    fontSize: "16px",
                    textAlign: "center",
                    marginBottom: "20px",
                    color: "#475467",
                    fontWeight: "700",
                  }}
                >
                  {`${this.props.progress} of 3 scores posted`}
                </p>
              </>
            )}
            <p
              style={{
                fontWeight: "500",
                color: "#475467",
                fontSize: "18px",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              {this.props.content}
            </p>

            <div className="actions centered" style={{ marginTop: "20px" }}>
              <button
                className="btn fill blue"
                onClick={() =>
                  Navigate.toPath("/challenges/" + this.props.challengeId)
                }
                style={{
                  maxWidth: "70%",
                  width: "70%",
                  padding: "10px",
                  fontSize: "19px",
                  marginBottom: "10px",
                }}
              >
                VIEW LEADERBOARD
              </button>
              <div className="share-row">
                <div
                  className="usga-share"
                  style={{ width: "21px", height: "21px" }}
                />
                <button
                  className="lnk white color-focus"
                  style={{
                    textAlign: "center",
                    fontSize: "17px",
                    color: "#00365F",
                    fontWeight: "700",
                    background: "white",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      window.location.origin +
                        `/challenges/${this.props.challengeId}`
                    );
                    showToast("Challenge link copied to clipboard!");
                  }}
                >
                  SHARE CHALLENGE
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

JoinedChallengeModal.defaultProps = {
  appElementName: "body",
  onCloseModal: () => {},
  onViewLeaderboard: () => {},
  onShareChallenge: () => {},
};

JoinedChallengeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func,
  onViewLeaderboard: PropTypes.func,
  onShareChallenge: PropTypes.func,
};

export default JoinedChallengeModal;
